var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-wrap-top"},[(_vm.item.item_type !== 'combo_item')?_c('regular-item',{attrs:{"item":_vm.item}}):_c('combo-item',{attrs:{"item":_vm.item}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }